import { Wallet } from "../../modules/DetailsCart";

export default function Cart() {
  
  return <Wallet />;
  
}
